import { API_GET_METHOD, API_POST_METHOD, API_PUT_METHOD } from 'global_config/constant-global';
import { axiosLabAPI } from 'services/axios';
import { showMessage } from 'services/settings/message';

export async function getUserTypes() {

  let userTypes = {
    data: [],
    status: null
  };

  try {
    const content = {
      method: API_GET_METHOD,
      url: `settings/usertype`,
    }

    const response = await axiosLabAPI(content);
    const { data } = await response;

    // Handle new API response format
    if (data && data.STATUSCODE === 200 && data.RECORDS) {
      userTypes = {
        data: data.RECORDS,
        status: 200
      };
    }
  }


  catch (e) {
    showMessage(e);
  }

  return userTypes;
}

export async function getUserTypesById(id) {
  let userTypes = {
    data: [],
    status: null
  };
  
  try {

    const content = {
      method: API_GET_METHOD,
      url: `listofvalues/usertypebyid`,
      params: {
        p_usertype_id: id,
      }
    }

    const response = await axiosLabAPI(content);
    const { data } = await response;

    // Handle new API response format
    if (data && data.STATUSCODE === 200 && data.RECORDS) {
      userTypes = {
        data: data.RECORDS,
        status: 200
      };
    }
  }
  catch (e) {
    showMessage(e);
  }

  return userTypes;
}


export async function createUserType(payload) {
  let userTypes = {};
  try {
    // Stringify modules if it exists
    const dataToSend = {
      ...payload,
      modules: payload.modules ? JSON.stringify(payload.modules) : null
    };

    const content = {
      method: API_POST_METHOD,
      url: `settings/usertype`,
      data: dataToSend
    }

    const response = await axiosLabAPI(content);
    const { data } = await response;

    if (data && data.STATUSCODE === 200) {
      userTypes = {
        data: data.RECORDS,
        status: 201, 
      };
    }
  }
  catch (e) {
    showMessage(e);
  }

  return userTypes;
}


export async function updateUserType(payload) {
  let userTypes = {};

  try {
    // Stringify modules if it exists
    const dataToSend = {
      ...payload,
      modules: payload.modules ? JSON.stringify(payload.modules) : null
    };
    
    const content = {
      method: API_PUT_METHOD,
      url: `settings/usertype`,
      data: dataToSend
    }

    const response = await axiosLabAPI(content);
    const { data } = await response;

    if (data && data.STATUSCODE === 200) {
      userTypes = {
        data: data.RECORDS,
        status: 200, // Return 200 for successful update
      };
    }
  }
  catch (e) {
    showMessage(e);
  }

  return userTypes;
}

